import * as React from 'react';

interface IFormErrorProps {
  message: string;
  newStyle?: boolean;
  isInfo?: boolean;
}

function Error({ message, newStyle, isInfo }: IFormErrorProps) {
  const breakLine = (text: string) => {
    const br = React.createElement('br');
    const regex = /(<br \/>)/g;
    return text
      .split(regex)
      .map((line: string, index: number) =>
        line.match(regex) ? <br key={`br-${index}`} /> : line
      );
  };

  return isInfo ? (
    <div style={{ fontWeight: 'bold', color: '#B3B3B3', paddingTop: '4px' }}>
      {breakLine(message)}
    </div>
  ) : (
    <div className={`${newStyle ? 'form-error-info' : 'err-color'} `} data-testid="CmdError">
      {breakLine(message)}
    </div>
  );
}

export default Error;
